// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-page-header[data-v-d45a6188]{display:block;background-color:#414141;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mobile-page-header .mobile-title[data-v-d45a6188]{padding-top:3px;padding-bottom:2px;border-bottom:5px solid #ed1c2f;background-color:#292929;font-weight:700;font-size:2rem;text-align:center;color:#ed1c2f}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
